import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, message, Select } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { Selection } from '~components';
const { Option } = Select;

const MaterialForm = ({ fields, isNew, id, reload, onChange, setLoading, dataSelected }) => {
  const inputRef = useRef(null);
  const [materialType, setMaterialType] = useState([]);
  const [unit, setUnit] = useState([]);
  const [companies, setCompanies] = useState([]);

  const getDataInit = async () => {
    const [getMarterialType, getUnit] = await Promise.all([
      ApiServices.getMarterialTypes(),
      ApiServices.getUnit(),
    ]);
    setMaterialType(getMarterialType.data.data);
    setUnit(getUnit.data.data);
  };

  const getCompanies = async (query = '') => {
    const newQuery = {
      Columns: {
        name: query,
      },
    };
    try {
      const res = await ApiServices.getCompanies(query ? newQuery : null);
      if (res?.data?.data) {
        setCompanies(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataInit();
    getCompanies();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsCodeMaterial(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 2) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Vật Tư này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Vật Tư này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createMaterial = async (data) => {
    try {
      const res = await ApiServices.createMaterial(data);
      if (res.data) {
        message.success('Tạo mới Vật Tư thành công');
        return reload();
      } else {
        message.error('Tạo mới Vật Tư thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Tạo mới Vật Tư thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updateMaterial = async (data) => {
    data.id = id;
    try {
      const res = await ApiServices.updateMaterial(id, data);
      if (res.data) {
        message.success('Cập nhật Vật Tư thành công');
        return reload();
      } else {
        message.error('Cập nhật Vật Tư thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Vật Tư thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createMaterial(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updateMaterial(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Mã Vật Tư'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Mã Vật Tư',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 3,
            message: 'Bạn phải nhập ít nhất 3 ký tự',
          },
        ]}
      >
        <Input placeholder='Mã Vật Tư' />
      </Form.Item>

      <Form.Item
        style={{ marginTop: '10px' }}
        name='name'
        label='Tên Vật Tư'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Tên Vật Tư',
          },
        ]}
      >
        <Input placeholder='Tên Vật Tư' />
      </Form.Item>

      <Form.Item
        style={{ marginTop: '10px' }}
        name='materialTypeCode'
        label='Loại Vật Tư'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Loại Vật Tư',
          },
        ]}
      >
        <Select showSearch placeholder='Loại Vật Tư'>
          {materialType.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        style={{ marginTop: '10px' }}
        name='unitCode'
        label='Đơn vị Tính'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Đơn vị Tính',
          },
        ]}
      >
        <Select showSearch placeholder='Đơn Vị Tính'>
          {unit.map(({ id, name }) => (
            <Option key={id} value={id}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item style={{ marginTop: '10px' }} name='otherInfo' label='Thông Số Khác'>
        <Input.TextArea placeholder='Thông Số Khác' />
      </Form.Item>
      <Form.Item
        name='companyId'
        label='Công Ty'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Công Ty',
          },
        ]}
      >
        <Selection
          labelDefault={dataSelected?.companyName || ''}
          data={companies}
          placeholder='Bạn phải chọn Công Ty'
          fieldValue='name'
          onSearch={getCompanies}
        />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { MaterialForm };
